$(function() {
    $('.choiceAddress').click(function () {
        $('.divAddress').css('outline', '1px solid #9EC5AC');
        $('#divAddress' + this.id).css('outline', '2px solid #E1AC64');
    });

    $('.rowAddress .divAddress,.carPay .divAddress').click(function () {
        $('.divAddress').css('outline', '1px solid #9EC5AC');
        $('#divAddress' + $(this).attr('number')).css('outline', '2px solid #E1AC64');
        $('input:radio[name="addressSelect"]').attr('checked', false);
        $("#addressSelect" + $(this).attr('number')).attr('checked', true);
        $("#selectAddress").submit();
    });

    $(".continuedBuyAddress").on('click', function () {
        if (!$("input:radio[name=addressSelect]").is(":checked")) {
            swal({
                title: "",
                text: "¡Debe escoger alguna dirección!",
                icon: imageURL,
            });
            return false;
        }
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });

        $("#selectAddress").submit();
    });

    $("#selectAddress").on('submit', function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        console.log(data);
        $.ajax({
            url: https + "selectAddress",
            method: "POST",
            data: data,
            success: function (data) {
                if ($.trim(data) == "1") {
                    location.reload();
                    //location.href = https + "carrito";
                } else if($.trim(data) == '2'){
                    swal({
                        text: 'No tenemos envio a esa ciudad',
                        icon: imageURL,
                        button: "OK!",
                    });
                }else{
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!",
                    });
                }

            }

        });

    });
});
